/**
 * kapcsolat form megjelenítő komponens
 * @author Koppany Kiss 2017.05.19.
 */
import kapcsolatFormTemplate from './kapcsolat-form.pug';
import vcRecaptcha from 'angular-recaptcha';
import {EMAIL_PATTERN, PHONE_PATTERN, SIMPLE_TEXT_PATTERN, NUMBER_PATTERN, MEMBERSHIP_PATTERN} from '../../../common/constants/consts';

const MODULE_NAME = 'kapcsolatForm';
class KapcsolatFormController {
	constructor($rootScope, vcRecaptchaService) {
		'ngInject';
		this.rootScope = $rootScope;
		this.vcRecaptchaService = vcRecaptchaService;
	}
	$onInit() {
		this.model = {};
		this.patterns = {
			email: EMAIL_PATTERN,
			phone: PHONE_PATTERN,
			simpleText: SIMPLE_TEXT_PATTERN,
			number: NUMBER_PATTERN,
			membership: MEMBERSHIP_PATTERN
		};
	}
	$onChanges(changeObject) {
		if (changeObject.initData && !changeObject.initData.isFirstChange()) {
			this.restTargyak = angular.copy(this.initData.targyak);
			this.captchaUrl = angular.copy(this.initData.captchaUrl);
			this.model.captchaId = angular.copy(this.initData.captchaId);
		}
		if (changeObject.errors && !changeObject.errors.isFirstChange()) {
			this.resetCaptcha();
			this.serverError = angular.copy(this.errors.data.errors);
			this.serverError.forEach((item) => {
				if (item.field == 'captcha' && item.message == 'invalid') {
					this.model.captchaValue = '';
					this.kapcsolatForm.captcha.$error.serverError = true;
				} else {
					this.rootScope.$broadcast('serverError');
				}
			});
		}
	}
	postContactForm() {
		if (this.kapcsolatForm.$valid) {
			this.postForm({
				emailObject: this.model
			});
		}
	}
	getCaptcha() {
		let now = new Date().getTime();
		this.captchaImage = this.captchaUrl.replace('{id}', `${this.model.captchaId}?${now}`);
	}

	changeOiselect(subjectId) {
		this.model.subjectId = subjectId;
	}

	resetCaptcha() {
		this.vcRecaptchaService.reload();
	}

	changeNativeSelect(subjectId) {
		for (let restTargy of this.restTargyak) {
			if (restTargy.subjectId == subjectId) {
				this.oiSelectModel = restTargy;
			}
		}
	}
}

export default angular.module(MODULE_NAME, [vcRecaptcha])
	.component('kapcsolatForm', {
		controller: KapcsolatFormController,
		template: kapcsolatFormTemplate(),
		bindings: {
			initData: '<',
			errors: '<',
			postForm: '&'
		}
	}).name;




// WEBPACK FOOTER //
// ../source/application/kapcsolat/kapcsolat-form/kapcsolat-form.js